import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "equimare_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  try {
    const actRaw = localStorage.getItem("equimare_act_as");
    if (actRaw) {
      const a = JSON.parse(actRaw);
      if (a?.tenant_id) config.headers["X-Act-As-Tenant"] = a.tenant_id;
    }
  } catch {
    /* ignore */
  }
  try {
    const farmRaw = localStorage.getItem("equimare_farm");
    if (farmRaw) {
      const f = JSON.parse(farmRaw);
      if (f?.id) config.headers["X-Farm-Tenant"] = f.id;
    }
  } catch {
    /* ignore */
  }
  return config;
});

/** FastAPI 422 returns an array of {msg} objects — flatten to a string so
    React never tries to render an object as a child. */
export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
